/* eslint-disable no-loop-func */
import React, { Component } from 'react';

import API from '../../../../utils/API';
import { Modal, ModalBody, UncontrolledTooltip } from 'reactstrap';

import Dropzone from 'react-dropzone';
import papa from 'papaparse';
import moment from 'moment';
import SelectField from '../../../../components/inputs/selectField';
import CheckboxInput from '../../../../components/inputs/checkboxInput';
import LoadingWizard from '../../../../components/spinner/wizard';
import { FixedSizeList as List } from 'react-window';

const UNMAPPED_DATA = 'Unmapped Data';
const GROUP_DATA = 'Group Data';


class ImportInventoryModal extends Component {
    constructor(props) {
        super(props);
        const unmappedData = {};
        unmappedData[UNMAPPED_DATA] = {};

        this.networkControllers = [];
        this.state = {
            files: [],
            accepted: [],
            rejected: [],
            overrideData: false,
            updateFNandLN: false,
            batchImport: false,
            customFields: [
                {
                    title: 'General Information',
                    _id: 0,
                    fields: [
                        { fieldName: 'Name', fieldType: 'text', _id: 'name' },
                        { fieldName: 'Category', fieldType: 'text', _id: 'category' },
                        { fieldName: 'Reference Number', fieldType: 'text', _id: 'referenceNumber' },
                        { fieldName: 'Vendor', fieldType: 'text', _id: 'vendor' },
                        { fieldName: 'Status', fieldType: 'text', _id: 'status' },
                        { fieldName: 'Tracking Number', fieldType: 'text', _id: 'trackingNumber' },
                        { fieldName: 'Arrival Date', fieldType: 'date', _id: 'arrivalDate' },
                        { fieldName: 'Post Event Plan', fieldType: 'text', _id: 'postEventPlan' },
                        { fieldName: 'Quantity', fieldType: 'number', _id: 'quantity' },
                        { fieldName: 'Price', fieldType: 'number', _id: 'price' },
                    ]
                }
            ],
            submitting: false,
            invalid: false,
            mapping: false,
            mappedData: {
                Category: {
                    Header: ['data1']
                }
            },
            unmappedData: unmappedData,
            fieldOptions: [],
            importedInventory: [],
            finished: false,
            importCount: 0,
            importLength: 0,
            importedGroups: [],
            importingGroups: false,
            isDuplicate: false,
            duplicateEmail: [],
            isInvalidEmail: false,
            invalidEmails: [],
            invalidPhones: [],
            nameExists: false,
            checked: [],
            filteredInventory: [],
            handledDuplicates: false,
            importedStarted: false,
            dupSelectedCount: 0,
            importError: false,
            errorCount: 0,
            currentSection: 0,
            sectionCount: 4,
            isError: false,
            cancelled: false,
            salesforceIntegration: props.event.integrations && props.event.integrations.salesforce && props.event.integrations.salesforce.campaignId ? true : false,
            submitToSalesforce: false,
            isInvalidPhoneNumber: false,
            invalidPhoneMessage: '',
            phoneValidationCompleted: false,
            validating: false,
            phoneValidationStarted: false,
            phoneNumberCurrentCount: 0,
            phoneNumberTotalCount: null,
            duplicateFieldNames: {}

        };
    }


    ValidateEmail(mail) {
        var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (mail.match(mailformat)) {
            return true;
        } else {
            return false;
        }
    }

    componentDidMount() {
        const { duplicateFieldNames, customFields } = this.state;
        customFields.forEach(category => {
            category.fields.forEach(field => {
                const fieldName = field.fieldName;
                if (!duplicateFieldNames[fieldName]) {
                    duplicateFieldNames[fieldName] = 1;
                } else {
                    duplicateFieldNames[fieldName]++;
                }
            });
        });
    }

    downloadCSVTemplate = () => {
        const mappedCategories = [];
        const mappedFieldNames = [];
        const mappedFieldTypes = [];
        this.state.customFields.forEach((category) => {
            category.fields.forEach((field) => {
                const fieldName = field.fieldName;
                mappedCategories.push(category.title);
                mappedFieldTypes.push(field.fieldType);
                mappedFieldNames.push(fieldName);
            });
        });
        const csv = papa.unparse([mappedFieldNames]);
        const filename = `InventoryImportTemplate.csv`;
        var file = new Blob([csv], { type: 'text/csv' });
        if (
            window.navigator.msSaveOrOpenBlob // IE10+
        )
            window.navigator.msSaveOrOpenBlob(file, filename);
        else {
            // Others
            var a = document.createElement('a'),
                url = URL.createObjectURL(file);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(function () {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        }
    };

    handleImport = () => {
        const { mappedData } = this.state;
        const attendees = [];
        Object.keys(mappedData).forEach((category) => {
            if (mappedData[category]._id !== 0 && mappedData[category]._id !== 1 && mappedData[category]._id !== 2) {
                Object.keys(mappedData[category]).forEach((field) => {
                    if (field !== '_id') {
                        const data = mappedData[category][field];
                        data.forEach((attendeeData, index) => {
                            if (index > 0) {
                                if (!attendees[index]) {
                                    attendees[index] = {
                                        metadata: []
                                    };
                                } else if (!attendees[index].metadata) {
                                    attendees[index] = {
                                        ...attendees[index],
                                        metadata: []
                                    };
                                }
                                attendees[index].metadata.push({
                                    categoryId: mappedData[category]._id,
                                    fieldId: data[0].value,
                                    fieldValue: attendeeData
                                });
                            }
                        });
                    }
                });
            } else if (mappedData[category]._id === 0) {
                Object.keys(mappedData[category]).forEach((field) => {
                    if (field !== '_id') {
                        const data = mappedData[category][field];
                        data.forEach((attendeeData, index) => {
                            if (index > 0) {
                                if (!attendees[index]) {
                                    attendees[index] = { metadata: [], roomingInformation: {}, travelInformation: {} };
                                }

                                attendees[index][data[0].value] = attendeeData;
                                attendees[index]['rowNumber'] = index + 1;
                            }
                        });
                    }
                });
            } else if (mappedData[category]._id === 1) {
                Object.keys(mappedData[category]).forEach((field) => {
                    if (field !== '_id') {
                        const data = mappedData[category][field];

                        data.forEach((attendeeData, index) => {
                            if (index > 0) {
                                if (!attendees[index]) {
                                    attendees[index] = {
                                        roomingInformation: {}
                                    };
                                } else if (!attendees[index].roomingInformation) {
                                    attendees[index] = {
                                        ...attendees[index],
                                        roomingInformation: {}
                                    };
                                }
                                attendees[index].roomingInformation[data[0].value] = attendeeData;
                            }
                        });
                    }
                });
            } else if (mappedData[category]._id === 2) {
                Object.keys(mappedData[category]).forEach((field) => {
                    if (field !== '_id') {
                        const data = mappedData[category][field];

                        data.forEach((attendeeData, index) => {
                            if (index > 0) {
                                if (!attendees[index]) {
                                    attendees[index] = {
                                        travelInformation: {}
                                    };
                                } else if (!attendees[index].travelInformation) {
                                    attendees[index] = {
                                        ...attendees[index],
                                        travelInformation: {}
                                    };
                                }
                                attendees[index].travelInformation[data[0].value] = attendeeData;
                            }
                        });
                    }
                });
            }
        });


        const filteredInventory = attendees.filter((attendee) => attendee.name && attendee.name !== '');

        this.setState(
            {
                submitting: true,
                mapping: false,
                importLength: filteredInventory.length,
                filteredInventory: filteredInventory
            },
            () => {
                this.validateData();
            }
        );
    };



    importAttendees = (attendees) => {
        try {
            this.importAttendee(attendees[0], attendees, 0, 0);
        } catch (ex) {
            console.log(ex);
            this.setState({
                invalid: true,
                submitting: false
            });
        }
    };

    uploadInventory = async (inventory) => {
        const { eventId, orgId } = this.props;
        this.setState({ importedStarted: true, submitting: true });
        let count = 0;
        const chunkSize = 10000;
        const inventoryChunks = [];
        const chunkCount = Math.ceil(inventory.length / chunkSize);

        for (let i = 0; i < chunkCount; i++) {
            inventoryChunks.push(inventory.slice(i * chunkSize, (i + 1) * chunkSize));
        }

        for (let i = 0; i < chunkCount; i++) {
            let inventoryList = inventoryChunks[i];
            if (this.state.cancelled) break;
            await API()
                .post(`Organizations/${orgId}/events/${eventId}/batchInventory`, {
                    inventoryList: inventoryList,
                })
                .then((res) => {
                    const { importedInventory } = this.state;
                    if (res.data) {
                        this.setState({
                            importCount: this.state.importCount + res.data.length,
                            importedInventory: [...importedInventory, ...res.data.map(inv => {
                                return {
                                    ...inv,
                                    success: true
                                };
                            })]
                        });
                    }
                    count++;

                    this.props.addImportedInventory(res.data);

                }).catch((e) => {

                    /* console.log(e);
                    const { importedInventory } = this.state;
                    count++;
                    inv.success = false;
                    inv.error = e.message === "Canceled" ? e.message :
                        e.response &&
                        (e.response.data.message
                            ? e.response.data.message
                            : e.response.data.email ? 'Attendee record exists' : e.response.data);
                    importedInventory.push(inv);
                    this.setState({ importedInventory: importedInventory, errorCount: this.state.errorCount + 1 });
                    this.props.addImportedInventory(importedInventory); */

                });
            if (i === chunkCount - 1) {
                this.setState({ finished: true });
            }
        }

    }

    uploadInventorytemp = async (inventory) => {
        const { eventId, orgId } = this.props;
        this.setState({ importedStarted: true, submitting: true });
        let count = 0;
        const chunkSize = 100;
        const inventoryChunks = [];
        const chunkCount = Math.ceil(inventory.length / chunkSize);

        for (let i = 0; i < chunkCount; i++) {
            inventoryChunks.push(inventory.slice(i * chunkSize, (i + 1) * chunkSize));
        }

        for (let i = 0; i < chunkCount; i++) {
            await new Promise((resolve, reject) => {
                count = 0;
                let currentInventoryList = inventoryChunks[i];

                for (let index = 0; index < currentInventoryList.length; index++) {
                    if (this.state.cancelled) break;
                    const inv = currentInventoryList[index];

                    const networkController = new AbortController();
                    this.networkControllers.push(networkController);
                    API()
                        .post(`Organizations/${orgId}/events/${eventId}/inventory`, {
                            ...inv,
                        }, { signal: networkController.signal })
                        .then((res) => {
                            const { importedInventory } = this.state;
                            if (res.data) {
                                res.data.success = true;
                                importedInventory.push(res.data);
                                this.setState({
                                    importCount: this.state.importCount + 1,
                                    importedInventory: importedInventory
                                });
                            }
                            count++;
                            if (count === currentInventoryList.length) {
                                resolve();
                                this.props.addImportedInventory(importedInventory);
                            }
                        })
                        .catch((e) => {
                            console.log(e);
                            const { importedInventory } = this.state;
                            count++;
                            inv.success = false;
                            inv.error = e.message === "Canceled" ? e.message :
                                e.response &&
                                (e.response.data.message
                                    ? e.response.data.message
                                    : e.response.data.email ? 'Attendee record exists' : e.response.data);
                            importedInventory.push(inv);
                            this.setState({ importedInventory: importedInventory, errorCount: this.state.errorCount + 1 });
                            if (count === currentInventoryList.length) {
                                resolve();
                                this.props.addImportedInventory(importedInventory);
                            }
                        });
                }
            }
            )

            if (i === chunkCount - 1) {
                this.setState({ finished: true });
            }
        }
    }


    validateData = async () => {
        const { mappedData } = this.state;
        let duplicateEmail = [];
        let isDuplicate = false;
        let isInvalidEmail = false;
        let nameExists = false;
        let invalidEmails = [];
        let invalidPhones = [];
        let fa = this.state.filteredInventory;
        this.setState({ validating: true });
        if (mappedData['General Information']) {


            if (mappedData['General Information']['Name']) {
                nameExists = true;
            }

        }
        let isError = false;
        isError = !nameExists;
        this.setState({
            nameExists: true,
            isInvalidEmail: isInvalidEmail,
            invalidPhones: invalidPhones,
            invalidEmails: invalidEmails,
            filteredInventory: fa,
            importLength: fa.length,
            isDuplicate: isDuplicate,
            duplicateEmail: duplicateEmail,
            submitting: false,
            validating: false,
            isError: isError
        }, () => {
            if (!isError) {
                this.uploadInventory(this.state.filteredInventory);
            }
        });
    };

    isRequiredMapped = () => {
        const { mappedData } = this.state;
        if (mappedData['General Information']) {
            if (!mappedData['General Information']['Name']) {
                this.setState({ nameExists: false });
            } else {
                this.setState({ nameExists: true });
            }
        }
    };

    onDrop = (files) => {

        papa.parse(files[0], {
            complete: (res) => {
                try {
                    /* Remove Trailing Whitespace */
                    const trimmedData = res.data.filter(subArray => {
                        let isEmptyRow = true;
                        subArray.forEach(data => {
                            if (data.trim() !== '') {
                                isEmptyRow = false;
                            }
                        })
                        return !isEmptyRow
                    })

                    const data = this.mapData(trimmedData);
                    const mappedData = data.mappedData;
                    const unmappedData = data.unmappedData;
                    const fieldData = this.state.customFields.map((category) => {
                        const title = category.title;
                        const headers = category.fields.map((header) => {
                            const name = header.fieldName;
                            return {
                                _id: header._id,
                                category: title,
                                categoryId: category._id,
                                value: name,
                                label: name
                            };
                        });
                        return {
                            label: title,
                            value: category._id,
                            options: headers
                        };
                    });
                    this.isRequiredMapped();
                    /* ?? */
                    if (!this.state.isDuplicate && !this.state.isInvalidEmail) {
                        this.setState({
                            mapping: true,
                            mappedData: mappedData,
                            unmappedData: unmappedData,
                            fieldOptions: fieldData
                        });
                    }
                } catch (e) {
                    console.log(e);
                    this.setState({ importError: true });
                }
            }
        });
        this.setState({
            files
        });
    };

    mapData = (csvData) => {
        const { customFields, duplicateFieldNames } = this.state;
        const csvHeaders = csvData[0];
        const mappedData = {};
        let usedFields = [];
        customFields.forEach((category) => {
            const categoryTitle = category.title;
            mappedData[categoryTitle] = {};
            mappedData[categoryTitle]._id = category._id;
            category.fields.forEach((field) => {
                let fieldName = field.fieldName;
                if (!usedFields.includes(fieldName)) {
                    mappedData[categoryTitle][fieldName] = [{ label: fieldName, value: field._id }];

                    let count = -1;
                    const headerIndex = csvHeaders.findIndex((csvHeader) => {
                        count++;
                        if (csvHeader.toLowerCase() === fieldName.toLowerCase()) {
                            if (duplicateFieldNames && duplicateFieldNames[fieldName] > 1) {
                                return false;
                            }
                            //fieldName = csvHeader;
                            if (!usedFields.find((o) => o.fieldName === fieldName && o.index === count)) {
                                usedFields.push({ fieldName: fieldName, index: count });
                                return true;
                            }
                        }
                        return false;
                    });
                    if (headerIndex > -1) {
                        mappedData[categoryTitle][fieldName][0].headerIndex = headerIndex;
                        csvData.forEach((row, index) => {
                            if (index > 0) {
                                if (!mappedData[categoryTitle][fieldName][index]) {
                                    mappedData[categoryTitle][fieldName][index] = [];
                                }
                                let value = null;
                                switch (field.fieldType) {
                                    case 'number':
                                        value = Number.parseFloat(row[headerIndex]);
                                        break;
                                    case 'date':
                                        value = row[headerIndex] ? moment(row[headerIndex]).format('YYYY-MM-DD') : '';
                                        break;
                                    case 'checkbox':
                                        value = row[headerIndex].toLowerCase() === 'yes' ? true : false;
                                        break;
                                    default:
                                        value = row[headerIndex];
                                }
                                mappedData[categoryTitle][fieldName][index] =
                                    typeof value == 'string' ? value.trim() : value;
                            }
                        });
                    }
                    if (mappedData[categoryTitle][fieldName].length < 2) {
                        delete mappedData[categoryTitle][fieldName];
                    }
                }
            });
            if (Object.keys(mappedData[categoryTitle]).length < 2) {
                delete mappedData[categoryTitle];
            }
        });

        const unmappedData = {};
        unmappedData[UNMAPPED_DATA] = {};
        csvHeaders.forEach((header, headerIndex) => {
            if (!usedFields.find((f) => f.fieldName === header && f.index === headerIndex)) {
                unmappedData[UNMAPPED_DATA][header.concat('-', headerIndex.toString())] = [
                    {
                        label: header,
                        value: header,
                        headerIndex: headerIndex
                    }
                ];
                csvData.forEach((row, index) => {
                    if (index > 0) {
                        unmappedData[UNMAPPED_DATA][header.concat('-', headerIndex.toString())][index] =
                            row[headerIndex];
                    }
                });
            }
        });
        if (mappedData['General Information']) {
            this.setState({
                nameExists: Object.keys(mappedData['General Information']).includes('Name'),
            });
        } else {
            this.setState({ nameExists: false });
        }

        return { mappedData, unmappedData };
    };



    FieldContainer = (category, header, columnData, index, size, isUnmapped) => {
        const selectedOption = {
            value: header,
            label: header
        };

        const dataPreview = JSON.parse(JSON.stringify(columnData));
        let data = '';
        for (let dataCount = 1; dataCount < dataPreview.length; dataCount++) {
            let current = dataPreview[dataCount];
            if (current) {
                data = current;
                break;
            }
        }
        return (
            <div className="w-100 mb-20" key={index}>
                <div className='flex aic jcsb'>
                    <div className='flex w-100'>


                        <div className='' style={{ width: 21 }}>
                        </div>

                        <div
                            className='w-100'
                            style={{
                                maxWidth: 283,
                                minWidth: 283,
                                width: 283,
                                border: isUnmapped ? `1px solid var(--danger)` : `1px solid var(--border)`,
                                borderRadius: 5,
                                padding: '3px 17px',
                                height: 40
                            }}>
                            <p>{columnData[0].label}</p>
                            <p style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}
                                className='small grey'>Ex: {data ? data : 'Blank column'}</p>
                        </div>

                    </div>
                    <i className="las la-arrow-right mr-5 ml-5"
                        style={{
                            color: category !== UNMAPPED_DATA && category !== GROUP_DATA ? 'var(--primary)' : '',
                        }}
                    />
                    <div className="w-100 mb-a">
                        <SelectField
                            label=""
                            style={{
                                maxWidth: 283,
                                minWidth: 283,
                                width: 283
                            }}
                            classes=" neu mb-0 "
                            value={category !== UNMAPPED_DATA && selectedOption}
                            options={this.state.fieldOptions}
                            formatGroupLabel={this.formatGroupLabel}
                            onChange={(data) => {
                                const selectedField = this.state.customFields
                                    .find(cat => cat.title === data.category)
                                    ?.fields.find(field => field._id === data._id);

                                if (selectedField && (selectedField._id === 'checkInDate' || selectedField._id === 'checkOutDate' || selectedField._id === 'arrivalDate' || selectedField._id === 'departureDate')) {
                                    for (let i = 1; i < columnData.length; i++) {
                                        const dateValue = columnData[i];
                                        if (dateValue && dateValue.toString().trim() !== '') {
                                            const momentDate = moment(dateValue, ['M/D/YY', 'MM/DD/YYYY', 'M/D/YYYY', 'MM/DD/YY', 'YYYY-MM-DD'], true);
                                            if (!momentDate.isValid()) {
                                                columnData[i] = '';
                                            }
                                        }
                                    }
                                }
                                if (category !== UNMAPPED_DATA) {
                                    const mappedData = this.state.mappedData;
                                    columnData[0] = { label: data.label, value: data._id };
                                    if (!mappedData[data.category]) {
                                        mappedData[data.category] = [];
                                        mappedData[data.category][data.label] = columnData;
                                        delete mappedData[category][header];
                                    } else if (!mappedData[data.category][data.label]) {
                                        mappedData[data.category][data.label] = columnData;
                                        delete mappedData[category][header];
                                    }
                                    this.setState({ mappedData: mappedData }, () => this.isRequiredMapped());
                                } else {
                                    const mappedData = this.state.mappedData;
                                    const unmappedData = this.state.unmappedData;
                                    columnData[0] = { label: columnData[0].label, value: data._id };
                                    if (!mappedData[data.category]) {
                                        mappedData[data.category] = {};
                                        mappedData[data.category]._id = data.categoryId;
                                        mappedData[data.category][data.label] = columnData;
                                        delete unmappedData[category][header];
                                    } else if (!mappedData[data.category][data.label]) {
                                        mappedData[data.category][data.label] = columnData;
                                        delete unmappedData[category][header];
                                    }

                                    this.setState({ mappedData: mappedData, unmappedData: unmappedData }, () =>
                                        this.isRequiredMapped()
                                    );
                                }
                            }}
                            additionalSelectElement={
                                category !== UNMAPPED_DATA || category === GROUP_DATA ? (
                                    <div
                                        className='c-pointer'
                                        style={{
                                            position: 'absolute',
                                            zIndex: 999,
                                            right: 30,
                                            top: 10
                                        }}
                                        onClick={() => {
                                            const mappedData = this.state.mappedData;
                                            const unmappedData = this.state.unmappedData;
                                            const propertyName = columnData[0].label.concat('-', columnData[0].headerIndex);
                                            if (!unmappedData[UNMAPPED_DATA]) {
                                                unmappedData[UNMAPPED_DATA] = [];
                                                delete mappedData[category][header];
                                                unmappedData[UNMAPPED_DATA][propertyName] = columnData;
                                            } else if (!unmappedData[UNMAPPED_DATA][propertyName]) {
                                                delete mappedData[category][header];
                                                unmappedData[UNMAPPED_DATA][propertyName] = columnData;
                                            } else if (unmappedData[UNMAPPED_DATA][propertyName]) {
                                                delete mappedData[category][header];
                                            }
                                            if (Object.keys(mappedData[category]).length < 2) {
                                                delete mappedData[category];
                                            }
                                            this.setState({ mappedData: mappedData, unmappedData: unmappedData }, () => {
                                                this.isRequiredMapped();
                                            });

                                        }}
                                    >
                                        <i class="lar la-times-circle grey"></i>
                                    </div>
                                ) : null
                            }
                        />

                    </div>
                </div>
            </div>
        );
    };




    cancelImport = async () => {
        this.setState({ cancelled: true });
        this.networkControllers.forEach(async (controller) => {
            try {
                controller.abort();
            } catch (e) {
                console.log(e);
            }
        });
    };

    render() {
        const { isOpen, toggle } = this.props;
        const {
            submitting,
            mapping,
            mappedData,
            unmappedData,
            finished,
            cancelled,
            importLength,
            importedInventory,
            nameExists,
            importedStarted,
            isError,

        } = this.state;
        const hasUnmappedData = Object.keys(unmappedData[UNMAPPED_DATA]).length > 0;
        let index = 0;
        let isButtonDisabled = false;
        isButtonDisabled = (!nameExists) // handles the case where the user has not mapped email and first name
            || importedStarted; //import has started
        console.log({ importedInventory });
        return (
            <Modal isOpen={isOpen} toggle={toggle} className="import importModal">
                <div className="modalHeader pb-0">

                    <button onClick={toggle} style={{ position: 'absolute', right: 5, top: 5, padding: 7 }}><i className='las la-times'></i></button>
                    <div className="headerContainer">
                        <h1>Import Inventory Data</h1>
                        {/* <h4>Step {currentSection + 1} of {sectionCount}</h4> */}
                    </div>
                </div>

                <ModalBody className="modalBody " >
                    {!importedStarted && mapping ? (
                        <div className={`sectionBody w-100 anim left`}
                            style={{
                                maxHeight: 400
                            }}
                        >
                            <div className='mb-20'>
                                <h4 className='mb-10'>Choose where your inventory data will go by mapping it to the relevant columns.</h4>

                                <div className='flex '>
                                </div>
                            </div>
                            <div className='scrollContainer'>


                                {(!nameExists) && (
                                    <p style={{ color: 'red' }}>
                                        Name is required and has not been mapped. Please map.
                                    </p>
                                )}
                                {hasUnmappedData &&
                                    <div>
                                        <div className='flex mb-10'>
                                            <h3 style={{ width: '50%' }}>Unmapped Data</h3>
                                            <h3 className='ml-25' style={{ width: '50%' }}>Attendee Column</h3>
                                        </div>
                                    </div>}
                                {hasUnmappedData && (<div className="importedDataRow">
                                    {Object.keys(unmappedData[UNMAPPED_DATA]).map((dataKey) =>
                                        this.FieldContainer(
                                            UNMAPPED_DATA,
                                            dataKey,
                                            unmappedData[UNMAPPED_DATA][dataKey],
                                            index++,
                                            true,
                                            true
                                        )
                                    )}
                                </div>
                                )}


                                {Object.keys(mappedData).map((key) => {
                                    if (key !== '_id') {
                                        const categoryData = mappedData[key];
                                        return (
                                            <div key={key}>
                                                <div>
                                                    <div className='flex mb-10'>
                                                        <h3 style={{ marginLeft: '20px', width: '50%' }}>{key}</h3>

                                                        <h3 className='ml-25' style={{ width: '50%' }}>Inventory Data</h3>
                                                    </div>
                                                </div>
                                                <div className="importedDataRow">
                                                    {Object.keys(categoryData).map(
                                                        (dataKey) =>
                                                            dataKey !== '_id' &&
                                                            this.FieldContainer(
                                                                key,
                                                                dataKey,
                                                                categoryData[dataKey],
                                                                index++,
                                                                hasUnmappedData
                                                            )
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    }
                                    return null;
                                })}
                            </div>
                        </div>
                    ) : !importedStarted && isError ? (
                        <div className={`sectionBody w-100  anim left ml-10`}>
                            {!isButtonDisabled ? <div className='text-c mb-40 mt-20'>
                                {importLength > 0 ? <h3 className='mb-10'>All Errors Resolved</h3> : <h3 className='mb-10'> No Data to Import</h3>}
                                {importLength > 0 ? <p className='mb-10'>You may begin to import your data.</p> : <p className='mb-10'>There is no data to be imported.</p>}
                            </div> : <div className='text-c mb-40 mt-20'>
                                <h3 className='mb-10'>Errors found in data</h3>
                                <p className='mb-10'>
                                    Please review and make the necessary changes to continue importing.
                                </p>
                            </div>}


                        </div>
                    ) : (
                        <div className={`sectionBody w-100 anim left`} >
                            {!importedStarted && !submitting ? (
                                <div>


                                    {!this.state.validating ? <div className='flex flex-wrap column w-100'>

                                        <div className='mb-20'>
                                            <h4 className='mb-10'>Import inventory data from a spreadsheet to the simple.events workspace.</h4>
                                        </div>

                                        <Dropzone
                                            accept="text/csv"
                                            className="clickable dropzone-details banner mb-10"
                                            style={{ height: 375 }}
                                            onDrop={this.onDrop.bind(this)}
                                        >
                                            <div>
                                                <div className="addIcon">
                                                    <i className="las la-plus"></i>
                                                </div>
                                                <p className='text-c'>
                                                    Add inventory CSV File<br />
                                                    or <span style={{ color: '#2B83F1' }}>Browse</span>
                                                </p>
                                            </div>
                                        </Dropzone>

                                        <div className='mb-40 mt-40 mt-20'>
                                            <h3>
                                                Need help getting started?
                                            </h3>
                                            <p>
                                                Make sure the data contains a column for name
                                            </p>
                                            <p>
                                                <span className='click seBlue c-pointer' onClick={this.downloadCSVTemplate}> Download </span> a sample CSV file
                                            </p>
                                        </div>
                                    </div>


                                        : < LoadingWizard text="Validating" loading={true} />}
                                </div>

                            ) : importedStarted ? (
                                <div className="flex column aic pt-20 h-100">
                                    <h2>
                                        {
                                            cancelled ? 'Import Stopped' :
                                                finished ? (
                                                    'Importing Complete'
                                                ) : !importedStarted ? (
                                                    'You may Import'
                                                ) : (
                                                    importedStarted && 'Importing Inventory...'
                                                )
                                        }
                                    </h2>
                                    {importedStarted && (
                                        <p className="mb-20">
                                            {(importedInventory.length - this.state.errorCount)} of {importLength} inventory{importLength === 1 ? '' : 's'}{' '}
                                            imported
                                        </p>
                                    )}

                                    <div className='sectionBlockAttendees'>

                                        <div className='sectionBlock'>
                                            <h3 className="pt-20">Imported Inventory</h3>
                                            {/* Virtualized List */}
                                            <List
                                                height={400}
                                                itemCount={importedInventory.length}
                                                itemSize={40}
                                                width={"100%"}
                                            >
                                                {({ index, style }) => {
                                                    const ia = importedInventory[index];
                                                    return (
                                                        <div className="importRow " style={style} key={ia._id}>
                                                            <div className='w-100'
                                                                style={{
                                                                    maxWidth: '50%',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                }}>{ia.name}</div>
                                                            <div className="statusContainer">
                                                                {ia.success ? 'Imported' : ia.error}
                                                                {ia.success ? (
                                                                    <i className="las la-check-circle green" />
                                                                ) : (
                                                                    <i className="las la-times-circle red" />
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                }}
                                            </List>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    )}
                </ModalBody>
                <div className={`flex mt-20 ${importedStarted ? 'mt-20' : ''}`}>
                    <button
                        onClick={submitting && !finished ? this.cancelImport : this.props.toggle}
                        outline
                        className={`neu ml-a mr-15 `}
                    >
                        {finished ? 'Close' : 'Cancel'}
                    </button>

                    {!finished && (!isError || importLength > 0) && <button
                        className={`neu  ${isButtonDisabled ? 'disabled' : 'prim'}`}
                        onClick={() => {
                            console.log({ isError });
                            if (isError) {
                            } else {
                                this.handleImport();
                            }
                        }
                        }
                    >
                        {(!submitting) && importedInventory.length === 0 ? (
                            'Add'
                        ) : cancelled ? (
                            'Cancelling...'
                        ) : (
                            'Importing Attendees...'
                        )}
                    </button>}

                </div>
            </Modal >
        );
    }
}

export default ImportInventoryModal;

const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
};
const groupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    color: '#172B4D',
    display: 'inline-block',
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center'
};
